/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const stripeGetCheckoutSession = /* GraphQL */ `
  query StripeGetCheckoutSession($sessionId: ID!) {
    stripeGetCheckoutSession(sessionId: $sessionId) {
      id
      amount_subtotal
      amount_total
      currency
      line_items {
        data {
          id
          amount_discount
          amount_subtotal
          amount_tax
          amount_total
          currency
          description
        }
      }
      locale
      metadata
      payment_status
      subscription {
        id
        cancel_at
        currency
        current_period_end
        current_period_start
        customer
        description
        ended_at
        metadata
        start_date
        status
        trial_end
        trial_start
      }
    }
  }
`;
export const stripeListPrices = /* GraphQL */ `
  query StripeListPrices {
    stripeListPrices {
      id
      active
      billing_scheme
      currency
      metadata {
        monthlyAccessQuantity
        userSeats
      }
      nickname
      product
      recurring {
        interval
        interval_count
        usage_type
      }
      tax_behavior
      type
      unit_amount
      unit_amount_decimal
      currency_options
    }
  }
`;
export const stripeListProducts = /* GraphQL */ `
  query StripeListProducts {
    stripeListProducts {
      id
      active
      default_price
      description
      livemode
      metadata {
        order
        userType
        subscription
      }
      name
    }
  }
`;
export const stripeGetProduct = /* GraphQL */ `
  query StripeGetProduct($id: ID!) {
    stripeGetProduct(id: $id) {
      id
      active
      default_price
      description
      livemode
      metadata {
        order
        userType
        subscription
      }
      name
    }
  }
`;
export const stripeGetSubscription = /* GraphQL */ `
  query StripeGetSubscription($id: ID!) {
    stripeGetSubscription(id: $id) {
      id
      cancel_at
      currency
      current_period_end
      current_period_start
      customer
      description
      ended_at
      metadata
      start_date
      status
      trial_end
      trial_start
    }
  }
`;
export const getSubscriptionStatus = /* GraphQL */ `
  query GetSubscriptionStatus {
    getSubscriptionStatus {
      monthlyAccessQuantity
      userSeats
      canUpgrade
      isOwner
      expiresAt
      isExpired
    }
  }
`;
export const getTranslation = /* GraphQL */ `
  query GetTranslation($language: String, $namespace: String) {
    getTranslation(language: $language, namespace: $namespace) {
      language
      namespace
      data
    }
  }
`;
export const listTranslations = /* GraphQL */ `
  query ListTranslations {
    listTranslations {
      language
      items {
        language
        namespace
        data
      }
    }
  }
`;
export const getAdmin = /* GraphQL */ `
  query GetAdmin($id: ID!) {
    getAdmin(id: $id) {
      country
      firstName
      lastName
      email
      phone
      role
      hasAccessed
      createdBy
      createdAt
      updatedAt
      id
      owner
    }
  }
`;
export const listAdmins = /* GraphQL */ `
  query ListAdmins(
    $filter: ModelAdminFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAdmins(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        country
        firstName
        lastName
        email
        phone
        role
        hasAccessed
        createdBy
        createdAt
        updatedAt
        id
        owner
      }
      nextToken
    }
  }
`;
export const getBilling = /* GraphQL */ `
  query GetBilling($id: ID!) {
    getBilling(id: $id) {
      customerId
      userId
      planId
      productId
      autoRenewProductId
      subscriptionId
      status
      trialUsed
      paymentProvider
      purchaseToken
      plan
      expiresAt
      cancelledAt
      createdAt
      updatedAt
      id
      owner
    }
  }
`;
export const listBillings = /* GraphQL */ `
  query ListBillings(
    $filter: ModelBillingFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listBillings(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        customerId
        userId
        planId
        productId
        autoRenewProductId
        subscriptionId
        status
        trialUsed
        paymentProvider
        purchaseToken
        plan
        expiresAt
        cancelledAt
        createdAt
        updatedAt
        id
        owner
      }
      nextToken
    }
  }
`;
export const getConversation = /* GraphQL */ `
  query GetConversation($id: ID!) {
    getConversation(id: $id) {
      title
      image {
        alt
        identityId
        key
        level
        type
      }
      country
      messages {
        items {
          conversationId
          text
          users
          receiver
          sender
          createdBy
          readBy
          createdAt
          updatedAt
          id
          conversationMessagesId
        }
        nextToken
      }
      userConversations {
        items {
          conversationId
          userId
          users
          createdAt
          updatedAt
          id
          conversationUserConversationsId
        }
        nextToken
      }
      productId
      product {
        title
        category
        description
        images {
          alt
          identityId
          key
          level
          type
        }
        tags
        locations
        country
        status
        owner
        teamId
        expiresAt
        createdAt
        updatedAt
        id
      }
      users
      readBy
      createdBy
      createdAt
      updatedAt
      id
    }
  }
`;
export const listConversations = /* GraphQL */ `
  query ListConversations(
    $filter: ModelConversationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listConversations(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        title
        image {
          alt
          identityId
          key
          level
          type
        }
        country
        messages {
          nextToken
        }
        userConversations {
          nextToken
        }
        productId
        product {
          title
          category
          description
          tags
          locations
          country
          status
          owner
          teamId
          expiresAt
          createdAt
          updatedAt
          id
        }
        users
        readBy
        createdBy
        createdAt
        updatedAt
        id
      }
      nextToken
    }
  }
`;
export const getUserConversation = /* GraphQL */ `
  query GetUserConversation($id: ID!) {
    getUserConversation(id: $id) {
      conversationId
      conversation {
        title
        image {
          alt
          identityId
          key
          level
          type
        }
        country
        messages {
          nextToken
        }
        userConversations {
          nextToken
        }
        productId
        product {
          title
          category
          description
          tags
          locations
          country
          status
          owner
          teamId
          expiresAt
          createdAt
          updatedAt
          id
        }
        users
        readBy
        createdBy
        createdAt
        updatedAt
        id
      }
      userId
      user {
        id
        identityId
        email
        about
        firstName
        lastName
        phone
        blocked
        blockedBy
        country
        profileImg {
          alt
          identityId
          key
          level
          type
        }
        interests
        locations
        facebook
        instagram
        twitter
        linkedin
        locale
        billingId
        billing {
          customerId
          userId
          planId
          productId
          autoRenewProductId
          subscriptionId
          status
          trialUsed
          paymentProvider
          purchaseToken
          plan
          expiresAt
          cancelledAt
          createdAt
          updatedAt
          id
          owner
        }
        onboardingStatus
        teamId
        team {
          billingId
          title
          ownerUserId
          createdAt
          updatedAt
          id
          owner
        }
        userType
        reportReasons
        createdAt
        updatedAt
        owner
      }
      users
      createdAt
      updatedAt
      id
      conversationUserConversationsId
    }
  }
`;
export const listUserConversations = /* GraphQL */ `
  query ListUserConversations(
    $filter: ModelUserConversationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUserConversations(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        conversationId
        conversation {
          title
          country
          productId
          users
          readBy
          createdBy
          createdAt
          updatedAt
          id
        }
        userId
        user {
          id
          identityId
          email
          about
          firstName
          lastName
          phone
          blocked
          blockedBy
          country
          interests
          locations
          facebook
          instagram
          twitter
          linkedin
          locale
          billingId
          onboardingStatus
          teamId
          userType
          reportReasons
          createdAt
          updatedAt
          owner
        }
        users
        createdAt
        updatedAt
        id
        conversationUserConversationsId
      }
      nextToken
    }
  }
`;
export const getMessage = /* GraphQL */ `
  query GetMessage($id: ID!) {
    getMessage(id: $id) {
      conversationId
      text
      attachments {
        identityId
        key
        level
        type
      }
      users
      receiver
      sender
      createdBy
      readBy
      createdAt
      updatedAt
      id
      conversationMessagesId
    }
  }
`;
export const listMessages = /* GraphQL */ `
  query ListMessages(
    $filter: ModelMessageFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listMessages(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        conversationId
        text
        attachments {
          identityId
          key
          level
          type
        }
        users
        receiver
        sender
        createdBy
        readBy
        createdAt
        updatedAt
        id
        conversationMessagesId
      }
      nextToken
    }
  }
`;
export const messagesByConversation = /* GraphQL */ `
  query MessagesByConversation(
    $conversationId: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelMessageFilterInput
    $limit: Int
    $nextToken: String
  ) {
    messagesByConversation(
      conversationId: $conversationId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        conversationId
        text
        attachments {
          identityId
          key
          level
          type
        }
        users
        receiver
        sender
        createdBy
        readBy
        createdAt
        updatedAt
        id
        conversationMessagesId
      }
      nextToken
    }
  }
`;
export const getOption = /* GraphQL */ `
  query GetOption($id: ID!) {
    getOption(id: $id) {
      name
      label
      value
      group
      createdAt
      updatedAt
      id
    }
  }
`;
export const listOptions = /* GraphQL */ `
  query ListOptions(
    $filter: ModelOptionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOptions(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        name
        label
        value
        group
        createdAt
        updatedAt
        id
      }
      nextToken
    }
  }
`;
export const optionsByName = /* GraphQL */ `
  query OptionsByName(
    $name: String!
    $label: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelOptionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    optionsByName(
      name: $name
      label: $label
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        name
        label
        value
        group
        createdAt
        updatedAt
        id
      }
      nextToken
    }
  }
`;
export const optionsByGroup = /* GraphQL */ `
  query OptionsByGroup(
    $group: String!
    $label: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelOptionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    optionsByGroup(
      group: $group
      label: $label
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        name
        label
        value
        group
        createdAt
        updatedAt
        id
      }
      nextToken
    }
  }
`;
export const getProduct = /* GraphQL */ `
  query GetProduct($id: ID!) {
    getProduct(id: $id) {
      title
      category
      description
      images {
        alt
        identityId
        key
        level
        type
      }
      tags
      locations
      country
      status
      owner
      teamId
      expiresAt
      createdAt
      updatedAt
      id
    }
  }
`;
export const listProducts = /* GraphQL */ `
  query ListProducts(
    $filter: ModelProductFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listProducts(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        title
        category
        description
        images {
          alt
          identityId
          key
          level
          type
        }
        tags
        locations
        country
        status
        owner
        teamId
        expiresAt
        createdAt
        updatedAt
        id
      }
      nextToken
    }
  }
`;
export const productsByStatus = /* GraphQL */ `
  query ProductsByStatus(
    $status: ProductStatus!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelProductFilterInput
    $limit: Int
    $nextToken: String
  ) {
    productsByStatus(
      status: $status
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        title
        category
        description
        images {
          alt
          identityId
          key
          level
          type
        }
        tags
        locations
        country
        status
        owner
        teamId
        expiresAt
        createdAt
        updatedAt
        id
      }
      nextToken
    }
  }
`;
export const productsByUser = /* GraphQL */ `
  query ProductsByUser(
    $owner: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelProductFilterInput
    $limit: Int
    $nextToken: String
  ) {
    productsByUser(
      owner: $owner
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        title
        category
        description
        images {
          alt
          identityId
          key
          level
          type
        }
        tags
        locations
        country
        status
        owner
        teamId
        expiresAt
        createdAt
        updatedAt
        id
      }
      nextToken
    }
  }
`;
export const productsByTeam = /* GraphQL */ `
  query ProductsByTeam(
    $teamId: String!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelProductFilterInput
    $limit: Int
    $nextToken: String
  ) {
    productsByTeam(
      teamId: $teamId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        title
        category
        description
        images {
          alt
          identityId
          key
          level
          type
        }
        tags
        locations
        country
        status
        owner
        teamId
        expiresAt
        createdAt
        updatedAt
        id
      }
      nextToken
    }
  }
`;
export const getTeam = /* GraphQL */ `
  query GetTeam($id: ID!) {
    getTeam(id: $id) {
      billingId
      title
      teamUsers {
        items {
          teamId
          userId
          createdAt
          updatedAt
          owners
          id
          teamTeamUsersId
        }
        nextToken
      }
      ownerUserId
      createdAt
      updatedAt
      id
      owner
    }
  }
`;
export const listTeams = /* GraphQL */ `
  query ListTeams(
    $filter: ModelTeamFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTeams(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        billingId
        title
        teamUsers {
          nextToken
        }
        ownerUserId
        createdAt
        updatedAt
        id
        owner
      }
      nextToken
    }
  }
`;
export const getTransaction = /* GraphQL */ `
  query GetTransaction($id: ID!) {
    getTransaction(id: $id) {
      userId
      billingId
      purchaseToken
      expiresAt
      createdAt
      updatedAt
      id
      owner
    }
  }
`;
export const listTransactions = /* GraphQL */ `
  query ListTransactions(
    $filter: ModelTransactionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTransactions(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        userId
        billingId
        purchaseToken
        expiresAt
        createdAt
        updatedAt
        id
        owner
      }
      nextToken
    }
  }
`;
export const getUser = /* GraphQL */ `
  query GetUser($id: ID!) {
    getUser(id: $id) {
      id
      identityId
      email
      about
      firstName
      lastName
      phone
      blocked
      blockedBy
      country
      profileImg {
        alt
        identityId
        key
        level
        type
      }
      interests
      locations
      facebook
      instagram
      twitter
      linkedin
      locale
      billingId
      billing {
        customerId
        userId
        planId
        productId
        autoRenewProductId
        subscriptionId
        status
        trialUsed
        paymentProvider
        purchaseToken
        plan
        expiresAt
        cancelledAt
        createdAt
        updatedAt
        id
        owner
      }
      onboardingStatus
      teamId
      team {
        billingId
        title
        teamUsers {
          nextToken
        }
        ownerUserId
        createdAt
        updatedAt
        id
        owner
      }
      userType
      reportReasons
      createdAt
      updatedAt
      owner
    }
  }
`;
export const listUsers = /* GraphQL */ `
  query ListUsers(
    $id: ID
    $filter: ModelUserFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listUsers(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        identityId
        email
        about
        firstName
        lastName
        phone
        blocked
        blockedBy
        country
        profileImg {
          alt
          identityId
          key
          level
          type
        }
        interests
        locations
        facebook
        instagram
        twitter
        linkedin
        locale
        billingId
        billing {
          customerId
          userId
          planId
          productId
          autoRenewProductId
          subscriptionId
          status
          trialUsed
          paymentProvider
          purchaseToken
          plan
          expiresAt
          cancelledAt
          createdAt
          updatedAt
          id
          owner
        }
        onboardingStatus
        teamId
        team {
          billingId
          title
          ownerUserId
          createdAt
          updatedAt
          id
          owner
        }
        userType
        reportReasons
        createdAt
        updatedAt
        owner
      }
      nextToken
    }
  }
`;
